import React,{Component} from 'react';
import fb from '../images/fb.svg';
import instagram from '../images/instagram.svg';
import {UISref} from 'ui-router-react'; 
import {createMarkup} from './Factory';

class Foot extends Component {
	constructor(props) {
		super(props);
		this.state = { 
		  newsletterClass:'',
		  email:'',
		  checkbox1:'',
		  checkbox2:'',
		  checkbox3:'',
		  checkbox3Error:'',
		  newsletter_overlay_status:'',
		  emailError:'',
		  checkbox1Error:'',
		  checkbox2Error:'',
		  submitted:false,
		  sucess:false,
		  submitText:this.props.staticData.label_anmelden
		}
		this.setWrapperRef = this.setWrapperRef.bind(this); 	
		this.overlayRef = this.overlayRef.bind(this); 	
		this.handleSubmit = this.handleSubmit.bind(this);		
		this.handleChange = this.handleChange.bind(this);		
		this.handleCheck1 = this.handleCheck1.bind(this);		
		this.handleCheck2 = this.handleCheck2.bind(this);		
		this.handleCheck3 = this.handleCheck3.bind(this);		
		this.handleClose = this.handleClose.bind(this);		
		this.toggleNewsletter = this.toggleNewsletter.bind(this);		
		this.handleClickError = this.handleClickError.bind(this);		
	}
	setWrapperRef(node) {
        this.wrapperRef = node;
    }
	overlayRef(node) {
        this.oRef = node;
    }
	handleClose(){
		this.setState({
			newsletter_overlay_status:''			
		});
		if(!this.state.sucess)
			this.setState({submitted:false})
		document.body.classList.toggle('no-scroll');
	}
	handleClickError(){
		this.setState({
			newsletter_overlay_status:'',
			submitted:false
		});
		document.body.classList.toggle('no-scroll');
	}
	handleChange(){
		this.setState({
			email:this.email.value
		});
		document.querySelector('#newsletter-email-id').classList.remove('formError')
	}
	handleCheck1(){
		this.setState({
			checkbox1:this.checkbox1.checked
		});
		document.querySelector('#nol-1').classList.remove('formError')
		document.querySelector('#nol-2').classList.remove('formError')
	}
	handleCheck2(){
		this.setState({
			checkbox2:this.checkbox2.checked
		});
		document.querySelector('#nol-2').classList.remove('formError')
		document.querySelector('#nol-1').classList.remove('formError')
	}
	handleCheck3(){
		this.setState({
			checkbox3:this.checkbox3.checked
		});
		document.querySelector('#nol-3').classList.remove('formError')
	}
	handleSubmit(e){
		//console.log(this.oRef)
		e.preventDefault();
		// eslint-disable-next-line 
		let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/; 
		let error = 0;
		if(!emailReg.test( this.state.email ) || this.state.email===''){
			this.setState({
				emailError:'formError'
			})
			error = 1;
		}
		if(this.state.checkbox1=="" && this.state.checkbox2==""){
			if(this.state.checkbox1==""){
				this.setState({
					checkbox1Error:'formError'
				})
			}
			if(this.state.checkbox2==""){
				this.setState({
					checkbox2Error:'formError'
				})
			}
			error = 1;
		}
		if(this.state.checkbox3==""){
			this.setState({
				checkbox3Error:'formError'
			})
			error = 1;
		}
		if(error){
			this.oRef.scroll({
				top: 0,
				behavior: "smooth"
			});
		}
		else if(emailReg.test( this.state.email ) && this.state.email!=='' && this.state.checkbox3){				
			this.setState({
				emailError:'',
				submitText:this.props.staticData.label_newsletter_progress
			});
			let dis = this;
			let xhttp = new XMLHttpRequest();
			xhttp.open("POST", document.ajaxPath, true);
			xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			xhttp.send("action=newsletter_data&email="+this.state.email+"&check1="+this.state.checkbox1+"&check2="+this.state.checkbox2);
			xhttp.onreadystatechange = function() {
			  if (this.readyState === 4 && this.status === 200) 
			  {
				if(this.responseText==="Success"){
					dis.setState({
						submitted:true,
						sucess:true,
						submitText:dis.props.staticData.label_anmelden
					});
				}else{ 
					dis.setState({
						submitted:true,
						sucess:false,
						submitText:dis.props.staticData.label_anmelden
					});
				}				
			  }
			}
		}
		// else{ 
		// 	this.setState({
		// 		checkbox3Error:'formError',
		// 		emailError:''
		// 	})
		// }
	}	
	toggleNewsletter(){
		let status = (this.state.newsletter_overlay_status==='')?'open':'';
		this.setState({
			newsletter_overlay_status:'open'
		})
		document.body.classList.toggle('no-scroll');
	}
	render(){	
		const {
			label_email_newsletter,label_austellungen,label_veranstaltungen,label_newsletter_submit,
			label_newsletter_sucess,label_newsletter_error,label_newsletter_progress,
			label_page_impressum,label_page_datenschutzerklärung,label_page_nutzungsbedingungen,
			label_obligatory_new,label_anmelden,label_required,label_conclude,label_select_topic
		} = this.props.staticData;
		return(
		<div id="footer_container">
		   <div className="newsletter-section">
               <div className="container-fluid lg-side-padding ">
                    <div className={`newsletter ${this.state.newsletterClass}`} ref={this.setWrapperRef} onClick={this.toggleNewsletter}>
                        <div className="newsletter-options">                                
							<input type="button" id="newsletter-submit" value={label_newsletter_submit} /> 
						</div>
                    </div>
                </div>
			</div>
			
			<footer className="site-footer container-fluid lg-side-padding">
				<div className="left-menu">
					<span className="notice">© 2017. TAXISPALAIS Kunsthalle Tirol  </span>     
					<ul className="menu">
						<li><UISref to="root.impressum"><a>{label_page_impressum}</a></UISref></li>
						<li><UISref to="root.datenschutzerklaerung"><a>{label_page_datenschutzerklärung}</a></UISref></li>
						<li><UISref to="root.nutzungsbedingungen"><a>{label_page_nutzungsbedingungen}</a></UISref></li>
					</ul>
				</div>
				<div className="right-menu">
					<a rel="noopener noreferrer" href="https://www.instagram.com/taxispalais/" target="_blank"><img className="insta" alt="instagram" src={instagram} /></a>
					<a rel="noopener noreferrer" href="https://www.facebook.com/taxispalais" target="_blank"><img alt="facebook" src={fb} /></a>
				</div>
			</footer>
			<div className={`fixed-overlay ${this.state.newsletter_overlay_status}`} ref={this.overlayRef}>
				<div className="overlay-wrapper">
					<i onClick={this.handleClose} className="close-overlay icon-close"></i>
					{
						(!this.state.submitted) ?
						<form className="clearfix newsletter" onSubmit={this.handleSubmit}>
							<h1 className="overlay-title">{label_newsletter_submit}</h1>
							<label className="margin-top-30" htmlFor="name">{label_email_newsletter}*</label>
							<input className={this.state.emailError} aria-label={label_email_newsletter} onChange={this.handleChange} type="email" id="newsletter-email-id" ref={(input) => { this.email = input; }} />
							<div className="newsletter-options">
								<div className="checkboxes">
									<label>{label_select_topic}:</label>
									<div className="checkgroup">
										<input className={this.state.emailError} value="1" onChange={this.handleCheck1} ref={(input) => { this.checkbox1 = input; }} aria-label={label_austellungen} type="checkbox" id="newsletter-option1" />
										<label id="nol-1" className={this.state.checkbox1Error} htmlFor="newsletter-option1"></label><p>{label_austellungen}</p>
									</div>
									<div className="checkgroup">
										<input value="1" onChange={this.handleCheck2} ref={(input) => { this.checkbox2 = input; }} aria-label={label_veranstaltungen} type="checkbox" id="newsletter-option2" />
										<label id="nol-2" className={this.state.checkbox2Error} htmlFor="newsletter-option2"></label><p>{label_veranstaltungen}</p>
									</div>
									<div className="checkgroup">
										<input value="1" onChange={this.handleCheck3} ref={(input) => { this.checkbox3 = input; }} aria-label={label_obligatory_new} type="checkbox" id="newsletter-option33" />
										<label id="nol-3" className={this.state.checkbox3Error} htmlFor="newsletter-option33"></label>
										<div dangerouslySetInnerHTML={createMarkup(label_obligatory_new)}></div>
									</div>
								</div>							
							</div>
							<div className="clearfix"></div>
							<input type="submit" className="btn dark-btn pull-right" value={this.state.submitText} />
							<div className="clearfix"></div>
							<label className="pull-left required">*{label_required}</label>
						</form>
						: (this.state.sucess) ?
							<div>
								<h1 className="overlay-title">{label_newsletter_sucess}</h1>
								<p className="margin-top-30">&nbsp;</p>
								<input type="button" className="btn dark-btn pull-right" value={label_conclude} onClick={this.handleClose} />
							</div>
							:
							<div>
								<h1 className="overlay-title">{label_newsletter_error}</h1>
								<p className="margin-top-30">&nbsp;</p>
								<input type="button" className="btn dark-btn pull-right" value={label_conclude} onClick={this.handleClickError} />
							</div>
					}
				</div>
			</div>
	   </div>
   )}
}

export default Foot


// WEBPACK FOOTER //
// ./src/components/Foot.js